import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/pages/home/components/Footer';
import { shippingContent } from '@/mocks/shippingData';

function ShippingPage() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />

      <article className="pt-[120px] pb-16">
        <div className="max-w-[860px] mx-auto px-6 md:px-10">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-foreground-500 text-sm font-label hover:text-foreground-950 transition-colors mb-8 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-arrow-left-line"></i>
            Back to Superbuy Spread
          </Link>

          <header className="mb-12">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-label font-medium mb-5 whitespace-nowrap">
              Money-Saving Guide
            </span>
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-5">
              {shippingContent.title}
            </h1>
            <p className="text-foreground-500 text-base md:text-lg leading-relaxed">
              {shippingContent.metaDescription}
            </p>
            <div className="flex items-center gap-4 mt-6 text-xs text-foreground-400 font-label">
              <span>Updated: July 2026</span>
              <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
              <span>15 min read</span>
              <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
              <span>By Superbuy Spread Team</span>
            </div>
          </header>

          <div className="rounded-2xl overflow-hidden mb-14 h-[300px] md:h-[420px]">
            <img
              src="https://readdy.ai/api/search-image?query=Professional%20product%20photography%20of%20several%20neatly%20packed%20cardboard%20shipping%20boxes%20in%20different%20sizes%20arranged%20on%20a%20minimalist%20light%20wooden%20table%20with%20a%20world%20map%20visible%20on%20the%20wall%20behind%20a%20tablet%20showing%20logistics%20tracking%20interface%20soft%20natural%20daylight%20from%20large%20window%20clean%20editorial%20aesthetic%20warm%20neutral%20tones&width=1720&height=860&seq=shipping-hero-2026-v2&orientation=landscape"
              alt="Superbuy Sheet shipping strategy optimization guide"
              className="w-full h-full object-cover"
              loading="eager"
            />
          </div>

          <div className="prose-custom">
            {shippingContent.sections.map((section, idx) => {
              if (section.isFaq) {
                return (
                  <section key={idx} className="mb-12">
                    <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-6">
                      {section.heading}
                    </h2>
                    <div className="space-y-4">
                      {section.faqs?.map((faq, fi) => (
                        <details key={fi} className="group bg-background-100 rounded-xl overflow-hidden">
                          <summary className="flex items-center justify-between px-6 py-4 cursor-pointer hover:bg-background-200/50 transition-colors">
                            <span className="text-foreground-800 font-label font-medium text-sm pr-4">{faq.q}</span>
                            <i className="ri-add-line text-foreground-400 group-open:hidden flex-shrink-0"></i>
                            <i className="ri-subtract-line text-foreground-400 hidden group-open:block flex-shrink-0"></i>
                          </summary>
                          <div className="px-6 pb-5">
                            <p className="text-foreground-600 text-sm leading-relaxed">{faq.a}</p>
                          </div>
                        </details>
                      ))}
                    </div>
                  </section>
                );
              }

              return (
                <section key={idx} className="mb-12">
                  <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-5 leading-snug">
                    {section.heading}
                  </h2>
                  <p className="text-foreground-600 text-base leading-relaxed whitespace-pre-line">
                    {section.content}
                  </p>
                </section>
              );
            })}
          </div>

          <div className="mt-16 p-8 md:p-10 bg-foreground-950 rounded-2xl text-center">
            <h3 className="font-heading text-2xl text-background-50 mb-3">
              Start saving on shipping today
            </h3>
            <p className="text-background-300 text-sm mb-6 max-w-md mx-auto leading-relaxed">
              Apply the Superbuy Sheet shipping methodology to your next haul and see how much you can save with organized planning.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-accent-500 text-background-50 text-sm font-label font-medium whitespace-nowrap cursor-pointer transition-all hover:bg-accent-400"
              >
                buy it now
                <i className="ri-arrow-right-up-line"></i>
              </a>
              <Link
                to="/"
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full border border-background-500 text-background-300 text-sm font-label font-medium whitespace-nowrap cursor-pointer transition-all hover:border-background-200 hover:text-background-100"
              >
                Back to Homepage
              </Link>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-200/70">
            <nav className="flex flex-wrap items-center gap-2 text-xs text-foreground-400 font-label">
              <Link to="/" className="hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap">Home</Link>
              <span>/</span>
              <span className="text-foreground-700 whitespace-nowrap">{shippingContent.title}</span>
            </nav>
            <div className="flex flex-wrap gap-4 mt-6">
              <Link to="/how-to-use-superbuy-sheet" className="text-xs text-foreground-500 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap">
                ← How To Use Superbuy Sheet
              </Link>
              <Link to="/superbuy-sheet-guide" className="text-xs text-foreground-500 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap">
                Ultimate Guide →
              </Link>
            </div>
          </div>
        </div>
      </article>

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Article",
          "headline": "Superbuy Sheet Shipping Strategy Guide: Save 30% on International Haul Costs in 2026",
          "description": "Master international shipping optimization with the Superbuy Sheet methodology. Learn weight consolidation strategies, shipping line comparisons, customs declaration tips, and haul planning techniques that save experienced shoppers hundreds of dollars per year.",
          "image": "https://readdy.ai/api/search-image?query=Professional%20product%20photography%20of%20several%20neatly%20packed%20cardboard%20shipping%20boxes%20in%20different%20sizes%20arranged%20on%20a%20minimalist%20light%20wooden%20table%20with%20a%20world%20map%20visible%20on%20the%20wall%20behind%20a%20tablet%20showing%20logistics%20tracking%20interface%20soft%20natural%20daylight%20from%20large%20window%20clean%20editorial%20aesthetic%20warm%20neutral%20tones&width=1720&height=860&seq=shipping-hero-2026-v2&orientation=landscape",
          "author": {"@type": "Organization", "name": "Superbuy Spread"},
          "publisher": {"@type": "Organization", "name": "Superbuy Spread", "logo": {"@type": "ImageObject", "url": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/67defc9f4dfae2c04004e8ea78b88107.png"}},
          "datePublished": "2026-07-01",
          "dateModified": "2026-07-13",
          "mainEntityOfPage": {"@type": "WebPage", "@id": "https://superbuyspread.mom/superbuy-shipping-strategy-guide"}
        })}
      </script>

      <Footer />
    </main>
  );
}

export default ShippingPage;